export default function ProjsProtocolStandardPages(){
  return(
    <div>
      Standard Pages coming soon! 
    </div>
  );
}